/**
 * Consumer corner modal — open/close with overlay click + Escape.
 * Migrated from consumer_corner_modal.html inline JS.
 */

export function openConsumerCorner(): void {
  const modal = document.getElementById("consumer-corner-modal-overlay");
  if (modal) {
    modal.classList.add("active");
    document.body.style.overflow = "hidden";
  }
}

export function closeConsumerCorner(): void {
  const modal = document.getElementById("consumer-corner-modal-overlay");
  if (modal) {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("consumer-corner-modal-overlay");
  overlay?.addEventListener("click", (e) => {
    if (e.target === overlay) closeConsumerCorner();
  });
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") closeConsumerCorner();
});

// Window exports for onclick handlers in templates
window.openConsumerCorner = openConsumerCorner;
window.closeConsumerCorner = closeConsumerCorner;
